<template>
    <v-card class="fill-height">
        <v-toolbar
                :class="toolbarTextColor"
                :color="toolbarColor"
                class="fill-height"
                flat>
            <v-breadcrumbs v-if="showBreadcrumbs" :class="toolbarTextColor" :items="breadcrumbs">
                <template v-slot:divider>
                    <v-icon color="accentText">mdi-chevron-right</v-icon>
                </template>
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item
                            :class="toolbarTextColor"
                            :disabled="item.disabled"
                            :exact="item.exact"
                            :href="item.href"
                            :to="item.to"
                            active-class="text--white"
                            class="body-1 breadcrumbs">
                        <v-toolbar-title>
                            {{ item.text }}
                        </v-toolbar-title>
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
            <slot name="header">
            </slot>
            <template v-if="items.length" v-slot:extension>
                <v-tabs v-model="tab" align-with-title
                        class="secondary "
                        color="">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                            v-for="(item, index) in items"
                            :key="index"
                            :replace="replaceRoute"
                            :to="item.to"
                            class="primary--text secondary"
                            @click="refreshPage">
                        {{ item.title }}
                    </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>
        <v-card v-if="$slots.default && (!subChildren || subComponent)" class="content-slot" flat>
            <v-card-text :class="{'fill-height': !fixedHeader, 'scroll' : fixedHeader}" class=" pa-2">
                <slot></slot>
            </v-card-text>
        </v-card>
        <v-card v-else class="content" flat>
            <v-card-text class="fill-height pa-2">
                <router-view :circleIds="circleIds" :zoneIds="zoneIds" :userId="userId" :filterOpen="filterOpen" class="fill-height"/>
            </v-card-text>
        </v-card>
    </v-card>
</template>

<script>
export default {
  name: "TabBasic",
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    showBreadcrumbs: {
      type: Boolean,
      required: false,
      default: false,
    },
    actualBreadcrumb: {
      type: Array,
      required: false,
      default: null,
    },
    circleIds: {
      type: [Array, null],
      required: false,
      default: null,
    },
    zoneIds: {
      type: [Array, null],
      required: false,
      default: null,
    },
    userId: {
      type: [Number, null],
      required: false,
      default: null,
    },
    toolbarColor: {
      type: String,
      required: false,
      default: 'accent'
    },
    toolbarTextColor: {
      type: String,
      required: false,
      default: 'accentText--text'
    },
    subComponent: {
      type: Boolean,
      required: false,
      default: false,
    },
    fixedHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    replaceRoute: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterOpen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      tab: null,
      refreshCount: 0,
    };
  },
  computed: {
    subChildren() {
      return this.$route.meta.subChildren;
    },
    breadcrumbs() {
      let breadcrumbs = [];
      if (['circleEdit', 'circleMemberAdd', 'circleHistory'].includes(this.$route.name)) {
        breadcrumbs = [
          {
            text: this.$t('menu.circles'),
            disabled: false,
            to: {
              name: 'circleMap'
            }
          },
        ];
      }
      if (['addZone', 'editZone', 'zoneManagement', 'geofenceHistory'].includes(this.$route.name)) {
        breadcrumbs = [
          {
            text: this.$t('menu.zones'),
            disabled: false,
            to: {
              name: 'zoneMap'
            }
          },
        ];
      }
      if (['locationHistory'].includes(this.$route.name)) {
        breadcrumbs = [
          {
            text: this.$t('notifications.users'),
            disabled: false,
            to: {
              name: 'users'
            }
          },
        ];
      }
      if (!this.$route.meta.label) {
        if (this.actualBreadcrumb) {
          return [...breadcrumbs, ...this.actualBreadcrumb];
        }
        return breadcrumbs;
      }
      return [...breadcrumbs, {
        text: this.$t(this.$route.meta.label),
        disabled: false
      }];
    }
  },
  methods: {
    refreshPage() {
      this.refreshCount++;
      this.$emit('refreshPage');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "tab-basic";
</style>